export const isMasterpiece = [{ text: 'All', value: 'all' }, { text: 'Yes', value: 'yes' }, { text: 'No', value: 'no' }]

export const onHold = [
  { text: 'All', value: 'all' },
  { text: 'Available', value: 'available' },
  { text: 'Reserved (Today)', value: 'onHold' },
  { text: 'Reserved (Today & in the future)', value: 'currentAndUpcoming' },
  { text: 'Reserved (Custom Period)', value: 'customPeriod' },
]

export const requested = [
  { text: 'All', value: 'all' },
  { text: 'Not Requested', value: 'notRequested' },
  { text: 'Requested', value: 'requested' },
]

export const source = [
  { text: 'Designer', value: 'designer' },
  { text: 'Imported', value: 'import' },
  { text: 'Mobile', value: 'mobile' },
  { text: 'Photo Station', value: 'station' },
  { text: 'Shipping', value: 'shipping' },
]
